<template>
    <v-main >
        <v-layout  justify-space-between>
            
            <v-flex lg6 xs12 v-show="!swipeDirection"  >

                   <v-card class="elevation-0 scroll-right px-lg-10 py-lg-5 px-2 py-5" v-touch="{left: () => swipe('Left'),right: () => swipe('Right'),}">
                    
                       <span class="font-weight-black text-lg-body-1 text-body-2">
                          Manager Review
                       </span>

                        <monthlyReport />
                    
                   </v-card>
                         
            </v-flex>



            
            <v-flex lg6 xs12 px-lg-10 px-5 mt-lg-n1  d-lg-flex v-show="swipeDirection" v-touch="{left: () => swipe('Left'),right: () => swipe('Right'),}" class="boxbg scroll-left scrollUp " >
                      <div class="mt-5"> 
                            

                            <ReviewForm />


                      </div>
            </v-flex>
            
     </v-layout>
    </v-main>
</template>

<script >

import monthlyReport from '@/components/MonitoringRating/Performance/managerReview/monthlyReviewReport'
import ReviewForm from '@/components/MonitoringRating/Performance/managerReview/managerReviewForm'
export default {
    name: 'classHandlingForm',
    components:{
     monthlyReport,
     ReviewForm
    },
    data: () => {
        return {
           
        }
    },
    
}

</script>
<style scoped>

</style>
<style scoped>

.boxbg {
    background-color:#F6F6F6 !important;
}
.monsterrat{
   font-family: 'Montserrat', serif !important;
}
html {
    font-family: 'Montserrat', serif !important;
    overflow-y: hidden !important;
}
.input-size{
    max-width: 142px !important;
}
.select-input{
    max-width: 142px !important;
}
.header{
    background-color:#E5E5E5;
    
}
.criteria{
    background-color: white !important;
}
@media only screen and (max-width: 1200px) {
.input-size{
            max-width: 100% !important;
}
.select-input{
    max-width: 82% !important;
}
.header{
    width: 100% !important;
    
}
}
</style>